import { closestCenter, pointerWithin } from '@dnd-kit/core'
import {
  horizontalListSortingStrategy,
  rectSortingStrategy,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'

import { isValueFunctionType } from '../../utils/common'

import { DRAG_DROP_SORT_STRATEGY } from './DragDrop.constants'

export function getDragDropSortingStrategy(strategy) {
  if (isValueFunctionType(strategy)) {
    return strategy
  }

  switch (strategy) {
    case DRAG_DROP_SORT_STRATEGY.horizontal:
      return horizontalListSortingStrategy
    case DRAG_DROP_SORT_STRATEGY.grid:
      return rectSortingStrategy
    case DRAG_DROP_SORT_STRATEGY.vertical:
    default:
      return verticalListSortingStrategy
  }
}

// The slot under the pointer wins; over a gap the nearest one takes over.
export function detectDragDropPointerCollision(args) {
  const collisions = pointerWithin(args)

  return collisions.length > 0 ? collisions : closestCenter(args)
}

// An item with interactive children stays usable when it cannot be dragged, so
// it is not exposed as disabled.
export function getDragDropDraggableAttributes({
  attributes,
  hasInteractiveChildren,
}) {
  return hasInteractiveChildren
    ? { ...attributes, 'aria-disabled': undefined }
    : attributes
}
